









import { Component, Vue } from 'vue-property-decorator';
import LeftNav from '../../components/LeftNav.vue';
import { NavList } from '@/store/pages/report/index.d';

@Component({
  components: {
    LeftNav,
  },
})
export default class Index extends Vue {
  private navList: NavList[] = [{
    name: '账号管理',
    icon: 'bi-icon-manager',
    path: '/index/accountAuthority/accountManage',
    hasAuth: false,
  }, 
  // {
  //   name: '角色管理',
  //   icon: 'bi-icon-limits',
  //   path: '/index/accountAuthority/rolesAuthority',
  //   hasAuth: false,
  // }
  ];
}
